import type { SentimentKey } from "./constants";

// Every spelling of the negative rating that reaches display code. `DISLIKE` is
// what the V1 hat/pathway write path persists, `NOT_FOR_ME` is the AppSync enum
// and what the reporting pipeline emits, and `NOTFORME` is MSHatDisplay's
// internal value. They all mean "Not for Me".
const NEGATIVE = new Set(["DISLIKE", "NOT_FOR_ME", "NOTFORME"]);

/**
 * Fold any stored sentiment spelling into the one key the display components
 * understand. Returns null for unrated, and for anything unrecognised — a
 * missing chip is better than a wrong one.
 *
 * Read-only: this never changes what gets written back.
 */
export const normalizeSentiment = (
  value: string | null | undefined,
): SentimentKey | null => {
  if (!value) return null;
  const upper = value.toUpperCase();
  if (NEGATIVE.has(upper)) return "NOT_FOR_ME";
  if (upper === "LOVE" || upper === "LIKE" || upper === "NOT_SURE") {
    return upper;
  }
  return null;
};
